import { Tag } from '../Tag';

type VehicleGroupsRepresentationProps = {
  vehicleGroups: string[];
};

export const VehicleGroupsRepresentation = ({
  vehicleGroups,
}: VehicleGroupsRepresentationProps) => {
  return (
    <div className="display-flex flex-wrap gap-5">
      {vehicleGroups.map((group) => (
        <Tag key={group}>{group}</Tag>
      ))}
    </div>
  );
};
